/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Position_Line_Down_TitleInputs */

const en_position_line_down_title = /** @type {(inputs: Position_Line_Down_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move Down One Line`)
};

const fr_position_line_down_title = /** @type {(inputs: Position_Line_Down_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descendre d'Une Ligne`)
};

const de_position_line_down_title = /** @type {(inputs: Position_Line_Down_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Zeile nach unten rücken`)
};

const it_position_line_down_title = /** @type {(inputs: Position_Line_Down_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spostati di una riga verso il basso`)
};

const ru_position_line_down_title = /** @type {(inputs: Position_Line_Down_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Спуститесь на одну строку вниз`)
};

const es_position_line_down_title = /** @type {(inputs: Position_Line_Down_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bajar una línea`)
};

const zh_cn2_position_line_down_title = /** @type {(inputs: Position_Line_Down_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`向下移动一行`)
};

const ja_position_line_down_title = /** @type {(inputs: Position_Line_Down_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1行下に移動`)
};

const hi_position_line_down_title = /** @type {(inputs: Position_Line_Down_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक पंक्ति नीचे जाएं`)
};

const pt_pt2_position_line_down_title = /** @type {(inputs: Position_Line_Down_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desça uma linha`)
};

/**
* | output |
* | --- |
* | "Move Down One Line" |
*
* @param {Position_Line_Down_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_line_down_title = /** @type {((inputs?: Position_Line_Down_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Line_Down_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_position_line_down_title(inputs)
	if (locale === "de") return de_position_line_down_title(inputs)
	if (locale === "it") return it_position_line_down_title(inputs)
	if (locale === "ru") return ru_position_line_down_title(inputs)
	if (locale === "es") return es_position_line_down_title(inputs)
	if (locale === "zh-CN") return zh_cn2_position_line_down_title(inputs)
	if (locale === "ja") return ja_position_line_down_title(inputs)
	if (locale === "hi") return hi_position_line_down_title(inputs)
	if (locale === "pt-PT") return pt_pt2_position_line_down_title(inputs)
	return en_position_line_down_title(inputs)
});